// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4bf7b21a","453":"46b4a424","728":"8ce8035e"}[chunkId] + ".chunk.js";
};